var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-menu',{attrs:{"scroll-pos":_vm.scrollPos}}),_c('v-header'),_c('v-section-summary'),_c('v-section-features'),_c('v-section-data'),_c('v-section-pricing'),_c('v-section-register'),_c('v-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }